/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMarketGemTransactionLogListRequest model module.
 * @module model/LogControllerDtoMarketGemTransactionLogListRequest
 * @version 1.0
 */
class LogControllerDtoMarketGemTransactionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoMarketGemTransactionLogListRequest</code>.
     * @alias module:model/LogControllerDtoMarketGemTransactionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoMarketGemTransactionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoMarketGemTransactionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketGemTransactionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketGemTransactionLogListRequest} The populated <code>LogControllerDtoMarketGemTransactionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketGemTransactionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('buyerAccount')) {
                obj['buyerAccount'] = ApiClient.convertToType(data['buyerAccount'], 'String');
            }
            if (data.hasOwnProperty('sellerAccount')) {
                obj['sellerAccount'] = ApiClient.convertToType(data['sellerAccount'], 'String');
            }
            if (data.hasOwnProperty('isGemRed')) {
                obj['isGemRed'] = ApiClient.convertToType(data['isGemRed'], 'Boolean');
            }
            if (data.hasOwnProperty('isGemBlue')) {
                obj['isGemBlue'] = ApiClient.convertToType(data['isGemBlue'], 'Boolean');
            }
            if (data.hasOwnProperty('isGemGreen')) {
                obj['isGemGreen'] = ApiClient.convertToType(data['isGemGreen'], 'Boolean');
            }
            if (data.hasOwnProperty('isGemYellow')) {
                obj['isGemYellow'] = ApiClient.convertToType(data['isGemYellow'], 'Boolean');
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketGemTransactionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketGemTransactionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoMarketGemTransactionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['buyerAccount'] && !(typeof data['buyerAccount'] === 'string' || data['buyerAccount'] instanceof String)) {
            throw new Error("Expected the field `buyerAccount` to be a primitive type in the JSON string but got " + data['buyerAccount']);
        }
        // ensure the json data is a string
        if (data['sellerAccount'] && !(typeof data['sellerAccount'] === 'string' || data['sellerAccount'] instanceof String)) {
            throw new Error("Expected the field `sellerAccount` to be a primitive type in the JSON string but got " + data['sellerAccount']);
        }
        // ensure the json data is a string
        if (data['level'] && !(typeof data['level'] === 'string' || data['level'] instanceof String)) {
            throw new Error("Expected the field `level` to be a primitive type in the JSON string but got " + data['level']);
        }

        return true;
    }


}

LogControllerDtoMarketGemTransactionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} buyerAccount
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['buyerAccount'] = undefined;

/**
 * @member {String} sellerAccount
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['sellerAccount'] = undefined;

/**
 * @member {Boolean} isGemRed
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['isGemRed'] = undefined;

/**
 * @member {Boolean} isGemBlue
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['isGemBlue'] = undefined;

/**
 * @member {Boolean} isGemGreen
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['isGemGreen'] = undefined;

/**
 * @member {Boolean} isGemYellow
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['isGemYellow'] = undefined;

/**
 * @member {String} level
 */
LogControllerDtoMarketGemTransactionLogListRequest.prototype['level'] = undefined;






export default LogControllerDtoMarketGemTransactionLogListRequest;

